import { Navigate, Route, Routes } from "react-router-dom";
import { ROUTER_PATHS } from "@/shared/config/router-paths";
import {
  BloodClinicalPage,
  UsersPage,
  VendorsPage,
  ProfilePageBO as ProfilePage,
  ContactUsPageBO as ContactUsPage,
  InventoryPage,
  ClientOrdersPage,
  VendorOrdersPage,
  ResearchAreasPage,
  NonInventoryPage,
  ClientCompaniesPage,
  InfectiousDonorsPage,
} from "@/pages";

export function BackOfficeRouter() {
  const {
    users,
    vendors,
    profile,
    contactUs,
    inventory,
    bloodClinical,
    biomarkers,
    infectiousDonors,
    nonInventory,
    clientOrders,
    vendorOrders,
    researchAreas,
    clientCompanies,
  } = ROUTER_PATHS.backOffice;

  return (
    <Routes>
      <Route path={users.path} element={<UsersPage />} />
      <Route path={vendors.path} element={<VendorsPage />} />
      <Route path={profile.path} element={<ProfilePage />} />
      <Route path={contactUs.path} element={<ContactUsPage />} />
      <Route path={inventory.path} element={<InventoryPage />} />
      <Route path={bloodClinical.path} element={<BloodClinicalPage />} />
      <Route path={clientOrders.path} element={<ClientOrdersPage />} />
      <Route path={vendorOrders.path} element={<VendorOrdersPage />} />
      <Route path={researchAreas.path} element={<ResearchAreasPage />} />
      <Route path={clientCompanies.path} element={<ClientCompaniesPage />} />
      <Route
        path={biomarkers.path}
        element={<Navigate to={`${bloodClinical.path}?tab=biomarkers`} replace />}
      />
      <Route path={infectiousDonors.path} element={<InfectiousDonorsPage />} />
      <Route path={nonInventory.path} element={<NonInventoryPage />} />
    </Routes>
  );
}
